<script setup lang="ts">
import { CircleCheck, X } from '@lucide/vue';
import SectionHeading from '@/components/marketing/shared/SectionHeading.vue';

const problems = [
    'Writing posts by hand, one channel at a time',
    'Rewriting the same idea for every platform',
    'Trying to remember what to post and when',
    'Not knowing which content actually worked',
];

const solutions = [
    'One assistant that knows your products and tone',
    'Platform-ready versions drafted for you',
    'A calendar that fills itself, ready for approval',
    'Plain-language summaries of what happened',
];
</script>

<template>
    <section id="why" class="scroll-mt-24 py-16 sm:py-20">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <SectionHeading
                eyebrow="Why it matters"
                title="Marketing work should not eat your week."
                description="You already know what your business does. LaunchStation handles the repetitive part."
            />

            <div class="mt-12 grid gap-6 lg:grid-cols-2">
                <div class="border-border bg-muted/40 rounded-xl border p-6">
                    <h3 class="text-lg">Marketing today</h3>
                    <ul class="mt-4 grid gap-3">
                        <li
                            v-for="item in problems"
                            :key="item"
                            class="text-muted-foreground flex items-start gap-3 text-sm"
                        >
                            <X
                                class="mt-0.5 size-4 shrink-0"
                                aria-hidden="true"
                            />
                            {{ item }}
                        </li>
                    </ul>
                </div>

                <div class="bg-card border-border rounded-xl border p-6">
                    <h3 class="text-lg">With LaunchStation</h3>
                    <ul class="mt-4 grid gap-3">
                        <li
                            v-for="item in solutions"
                            :key="item"
                            class="flex items-start gap-3 text-sm"
                        >
                            <CircleCheck
                                class="text-secondary mt-0.5 size-4 shrink-0"
                                aria-hidden="true"
                            />
                            {{ item }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>
